import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, requireCustomer = false, adminOnly = false }) => {
  const { user, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // For admin-only pages (like admin login), redirect logged-in non-admin users
  if (adminOnly && user && userProfile?.role !== 'admin') {
    return <Navigate to="/user-dashboard" replace />;
  }

  // For protected routes that require authentication
  if (!user) {
    // Redirect to appropriate login based on route type
    if (requireAdmin) {
      return <Navigate to="/admin-login-screen" replace />;
    }
    return <Navigate to="/login-screen" replace />;
  }

  // For customer-only routes, redirect admins to admin console
  if (requireCustomer && userProfile?.role === 'admin') {
    return <Navigate to="/admin-console" replace />;
  }

  // For admin-required routes, check role and redirect non-admins to customer dashboard
  if (requireAdmin && userProfile?.role !== 'admin') {
    return <Navigate to="/user-dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;